import Vue from 'vue'
import Vuex from 'vuex'
import snackBar from './modules/Snackbar';
import deleteWarning from './modules/DeleteWarning';
import reasonModal from './modules/ReasonModal';
import createLead from './modules/Los/CreateLead'
import losDetails from './modules/Los/Details'
import loanHistory from './modules/Lms/loanHistory'
import noticeModal from './modules/NoticeManagement';
import losFilter from './modules/Los/Filters/index';
import ledgerFilter from './modules/Ledger/Filters/index';
import ledgerChart from './modules/Ledger/Chart/index';
import lmsFilter from './modules/Lms/Filters/index';
import disbursmentFilter from './modules/Disbursement/Filters/index';
import collectionFilter from './modules/Collection/Filters/index';
import loanSchemeFilters from './modules/LoanScheme/Filters/index';
import teamFilters from './modules/Team/Filters/index';
import drawer from './modules/drawer';
import paymentFilters from './modules/Payments/Filters/index';
import reportsFilters from './modules/Reports/Filters/index';
import agentFilters from './modules/Agent/index';
import nachFilters from './modules/NACH/Filters/index';
import notificationFilters from './modules/Notifications/Filters/index';
import autoDebitFilters from './modules/NACH/AutoDebitFilters/index';
import comments from './modules/Comments/index';
import pdfViewer from './modules/PdfViewer/index';
import accountConflict from './modules/AccountConflict/index';
import filterLock from './modules/FilterLock/index';
import access from './modules/access';
import session from './modules/session';
import sessionHistoryFilters from './modules/SessionHistory/Filters/index';
Vue.use(Vuex)


const state = {
  search_text: "",
  drawer_flag: true,
  // The section list route the user last browsed (e.g. "collection-list").
  // Used so a search from a detail page returns to where the user started,
  // even when that detail page belongs to a different section (e.g. a
  // Collection list opens an LMS-details page).
  last_list_route: "",
};

const getters = {
  getSearchText: (state) => {
    return state.search_text;
  },
  getDrawerFlag: (state) => {
    return state.drawer_flag;
  },
  getLastListRoute: (state) => {
    return state.last_list_route;
  }
}

const mutations = {
  SET_SEARCH_TEXT: (state, value) => {
    state.search_text = value
  },
  SET_DRAWER_FLAG: (state) => {
    state.drawer_flag = !state.drawer_flag
  },
  SET_LAST_LIST_ROUTE: (state, value) => {
    state.last_list_route = value
  }
};

const actions = {
  setSearchText: ({ commit }, value) => {
    commit("SET_SEARCH_TEXT", value)
  },
  setDrawerFlag: ({commit}) => {
    commit("SET_DRAWER_FLAG");
  },
  setLastListRoute: ({ commit }, value) => {
    commit("SET_LAST_LIST_ROUTE", value)
  }
};


/**
 * Filter/tab state that must survive a page reload.
 *
 * These modules already persist across in-app navigation (they live in the
 * store), but a browser reload or hard reload rebuilds the store from
 * initialState(), which dropped the user back on the default tab — losing the
 * sub-tab they were working in on Leads (agent-los) and the LOS list.
 *
 * sessionStorage, not localStorage, on purpose: a list view belongs to the tab
 * it was set in (the login itself is shared by every tab, see app-js/authStorage),
 * and logout (app-js/session.js) clears sessionStorage in every tab, so a
 * persisted view can never outlive the user who set it.
 */
const PERSISTED_MODULES = ["agentFilters", "losFilter", "filterLock"];
const PERSIST_PREFIX = "orrish.filters.";

const store = new Vuex.Store({

  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  modules: {
    snackBar,
    deleteWarning,
    reasonModal,
    createLead,
    loanHistory,
    noticeModal,
    losDetails,
    losFilter,
    lmsFilter,
    ledgerFilter,
    ledgerChart,
    disbursmentFilter,
    collectionFilter,
    loanSchemeFilters,
    teamFilters,
    paymentFilters,
    drawer,
    reportsFilters,
    agentFilters,
    nachFilters,
    notificationFilters,
    autoDebitFilters,
    comments,
    pdfViewer,
    accountConflict,
    filterLock,
    access,
    session,
    sessionHistoryFilters
  }
})

PERSISTED_MODULES.forEach((name) => {
  const moduleState = store.state[name];
  if (!moduleState) return;

  // Rehydrate. Only keys the module still declares are copied back, so a
  // renamed/removed filter in a later release cannot resurrect itself from a
  // stale session, and assigning onto the existing reactive object keeps
  // Vue's reactivity intact.
  //
  // The module has not been touched yet, so its current values ARE
  // initialState() -- snapshot them first and use them as the declared shape.
  // A persisted value that contradicts that shape is a poisoned session, not a
  // preference: a multi-select filter written as a scalar throws in every
  // consumer that indexes it (`f.executive_name.length`), and because the throw
  // happens while rendering the list page's root element Vue swallows it into an
  // empty vnode -- the page goes completely blank, with no way for the user to
  // clear the filter that caused it. Keeping the default instead means a session
  // already carrying a bad value heals itself on the next load.
  const declared = Object.assign({}, moduleState);
  try {
    const saved = JSON.parse(sessionStorage.getItem(PERSIST_PREFIX + name) || "null");
    if (saved && typeof saved === "object") {
      Object.keys(moduleState).forEach((key) => {
        if (!Object.prototype.hasOwnProperty.call(saved, key)) return;
        if (Array.isArray(declared[key]) && !Array.isArray(saved[key])) return;
        moduleState[key] = saved[key];
      });
    }
  } catch (e) {
    // A malformed/blocked store must never stop the app booting.
  }

  // watch (not subscribe): these filters are assigned directly on the state by
  // the list screens (e.g. `this.filters.lead_status = "Pending"`) rather than
  // through mutations, so a mutation subscriber would never fire.
  store.watch(
    (s) => s[name],
    (value) => {
      try {
        sessionStorage.setItem(PERSIST_PREFIX + name, JSON.stringify(value));
      } catch (e) {
        // Quota/private-mode failures are not worth breaking a filter change over.
      }
    },
    { deep: true }
  );
});

export default store;
